<dx-popup
  title="LIGNES NON COMMANDÉES - DÉLAI DE COMMANDE DÉPASSÉ"
  [visible]="visible()"
  [width]="'80%'"
  [height]="'80%'"
  [showCloseButton]="false"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [hideOnOutsideClick]="false">

  <div class="custom-datagrid-container">
    <p>
      <i class="fas fa-exclamation-triangle danger-color space"></i>
      Les lignes suivantes n'ont pas pu être commandées car aucun créneau de livraison n'est disponible dans les délais.
    </p>
    <dx-data-grid
      [dataSource]="livraisonImpossibleList()"
      [showBorders]="true"
      [columnAutoWidth]="true"
      [rowAlternationEnabled]="true"
      [showColumnHeaders]="true"
      class="datagrid"
      (onExporting)="onExporting($event)"
    >
      <dxo-group-panel [visible]="true" emptyPanelText="Glisser une colonne ici pour grouper"></dxo-group-panel>
      <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true" fileName="lignes-non-commandees"></dxo-export>
      <dxi-column dataField="article" caption="Article"></dxi-column>
      <dxi-column dataField="fournisseur" caption="Fournisseur"></dxi-column>
      <dxi-column dataField="qteUC" caption="Qté UC"></dxi-column>
      <dxi-column dataField="dateLivraison" caption="Date livraison"></dxi-column>
      <dxi-column dataField="dateAppro" caption="Date appro"></dxi-column>
      <dxi-column dataField="dateFab" caption="Date fab"></dxi-column>
    </dx-data-grid>
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        label="Fermer et continuer"
        (onClick)="close()">
      </yo-button>
    </div>
  </div>
</dx-popup>
